import { Modal } from "antd";

export function appConfirmModal(options = {}) {
  const { okButtonProps, ...rest } = options;

  return Modal.confirm({
    centered: true,
    width: 416,
    okButtonProps: {
      ...okButtonProps,
      style: {
        backgroundColor: "var(--ant-primary-color)",
        borderColor: "var(--ant-primary-color)",
        ...(okButtonProps?.style || {}),
      },
    },
    ...rest,
  });
}
